import { render, staticRenderFns } from "./DisbursementStatusForm.vue?vue&type=template&id=4dcb9a42"
import script from "./DisbursementStatusForm.vue?vue&type=script&lang=js"
export * from "./DisbursementStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports